export default __webpack_public_path__ + "static/media/shape-1.4d91644c.svg";